export default __webpack_public_path__ + "static/media/innovation-image.a8a919c2.png";